import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'tab-custom-fields',
  templateUrl: './tab-custom-fields.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TabCustomFieldsComponent {
  @Input() customFieldsArray: FormArray;
  @Input() isViewMode: boolean;

  constructor() { }
}
